import React from "react";
import FulfillmentPage from "./FulfillmentPage";

const DocumentsPage = () => <FulfillmentPage embedded mode="documents" />;

export default DocumentsPage;
